"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shades = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Shades = () => {
  const {
    shades
  } = (0, _contexts.useSearchPreviewProduct)();
  const productShades = (0, _react.useMemo)(() => shades ?? [], [shades]);
  const shadesToRender = (0, _react.useMemo)(() => productShades.slice(0, _constants.MAX_VISIBLE_SHADES_COUNT).map(shade => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Shade, {
    shade: shade,
    size: _presentationComponents.ShadeSize.Small,
    testId: _constants.SEARCH_SHADE
  }, shade.productCode)), [productShades]);
  if (productShades.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [shadesToRender, productShades.length > _constants.MAX_VISIBLE_SHADES_COUNT ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      color: "textPrimary",
      variant: "overline",
      fontWeight: "bold",
      lineHeight: "normal",
      children: ["+", productShades.length - _constants.MAX_VISIBLE_SHADES_COUNT]
    }) : null]
  });
};
exports.Shades = Shades;
